import React from 'react';
import Input from '../components/general/Input';

class ZipBox extends React.Component {
  render() {
    const { getDistributionPoints, handleChange, errors, loaders } = this.props;
    return (
      <div>
        <div class="mx-auto hidden md:block max-w-md mb-12">
          <form onSubmit={e => e.preventDefault()} class="mt-10 flex rounded-md shadow-sm">
            <div class="relative flex items-stretch flex-grow focus-within:z-10">
              <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                </svg>
              </div>
              <Input
                autofocus={true}
                onChange={e => handleChange('zipCode', e.target.value)}
                id="zip"
                className="py-5 mr-20 form-input block w-full rounded-md pl-12 pr-12 text-xl transition ease-in-out duration-150 sm:text-sm sm:leading-5 focus:shadow-none focus:outline-none"
                placeholder="ENTER ZIP CODE"
                type="number"
                error={errors.zipCode}
              />
            </div>
            <button
              type="submit"
              onClick={getDistributionPoints}
              class="z-10 px-12 text-xl ml-4 relative py-2 leading-5 font-bold rounded-md text-white bg-gradient-to-r from-red-500 to-yellow hover:from-yellow hover:to-red-500 focus:outline-none focus:shadow-outline-black focus:border-black-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
            >
              {loaders.zipCodeLoader ? (
                <span class=""> LOADING... </span>
              ) : (
                <span class=""> CHECK RATE </span>
              )}
            </button>
          </form>
        </div>

        <div class="block md:hidden max-w-md mb-12">
          <div class="mt-10 rounded-md shadow-sm">
            <div class="relative  items-stretch flex-grow focus-within:z-10">
              <div class="absolute inset-y-0 left-0 pl-28 flex items-center pointer-events-none">
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                </svg>
              </div>
              <Input
                onChange={e => handleChange('zipCode', e.target.value)}
                id="zip"
                className="text-center py-5 form-input block w-full rounded-l-md rounded-l-md text-xl transition ease-in-out duration-150 sm:text-sm sm:leading-5 focus:shadow-none focus:outline-none"
                placeholder="ENTER ZIP CODE"
                type="number"
                error={errors.zipCode}
              />
            </div>
            <button
              onClick={getDistributionPoints}
              class="mt-2 w-full text-xl relative py-5 leading-5 font-bold rounded-md text-white bg-yellow hover:text-black focus:outline-none focus:shadow-outline-black focus:border-black-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
            >
              <span class=""> CHECK RATE </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ZipBox;
